enum ScaleModeType {
    KNOWN,
    USER
}

export default ScaleModeType;

export type FileContentTypeDescription = {
    contentType: ScaleModeType;
    description: string;
}

export const labels: FileContentTypeDescription[] = [
    {
        contentType: ScaleModeType.KNOWN,
        description: "Echelle indiquée sur le plan",
    },
    {
        contentType: ScaleModeType.USER,
        description: "Echelle mesurée sur le plan",
    },
];